import { axios } from '@Root/API'

export const remove = (engagementId, id) => {
	return axios.delete(`student-engagement/${engagementId}/accreditation-aim/${id}`)
}
